import EvaluateProcessLegal from "./EvaluateProcess.vue"
export default EvaluateProcessLegal